<app-loader *ngIf="ticketInfoLoading"></app-loader>
<div *ngIf="ticketInfo">
  <div class="no-print">
    <div class="title title--big">Заявка №{{ ticketInfo.hd_ticket_number }}</div>
  </div>
  <div class="grid mt-32 no-print">
    <div class="grid__box grid__box--size-6">
      <div>
        <div class="grid mt-8 mb-8">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Тип</span>
          </div>
          <div class="grid__box grid__box--size-9">
            <span class="title title--s">{{ ticketInfo.ticket_type && ticketInfo.ticket_type.name }}</span>
            <span *ngIf="ticketInfo.ticket_subtype"> / {{ ticketInfo.ticket_subtype }}</span>
          </div>
        </div>
        <div *ngIf="ticketInfo.ticket_type && ticketInfo.ticket_type.id === 4">
          <div class="grid mt-8 mb-8">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Масштаб</span>
            </div>
            <div class="grid__box grid__box--size-9">
              {{ ticketInfo.scale_and_priority }}
            </div>
          </div>
          <div class="grid mt-8 mb-8">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Период действия</span>
            </div>
            <div class="grid__box grid__box--size-9">
              {{ ticketInfo.period }}
            </div>
          </div>
          <div class="grid mt-8 mb-8">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Влияние на сервис</span>
            </div>
            <div class="grid__box grid__box--size-9">
              {{ ticketInfo.affected_services }}
            </div>
          </div>
        </div>
        <div class="grid mt-8 mb-8">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Адрес</span>
          </div>
          <div class="grid__box grid__box--size-9">
            {{ ticketInfo.hd_address }}
          </div>
        </div>
        <div class="grid mt-8 mb-8" *ngIf="ticketInfo.ticket_type && ticketInfo.ticket_type.id === 4">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Описание</span>
          </div>
          <div class="grid__box grid__box--size-9">
            {{ ticketInfo.description }}
          </div>
        </div>
        <div class="grid mt-8 mb-8">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Участок</span>
          </div>
          <div class="grid__box grid__box--size-9">
            {{ ticketInfo.district && ticketInfo.district.sector_number_str }}
          </div>
        </div>
        <div class="grid mt-8 mb-8">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Назначена на бригаду</span>
          </div>
          <div class="grid__box grid__box--size-9">
            <span *ngIf="ticketInfo.brigade">
              <app-brigade-popover [brigade]="ticketInfo.brigade"></app-brigade-popover>
            </span>
            <span *ngIf="!ticketInfo.brigade"> Не назначена </span>
          </div>
        </div>
        <div class="grid mt-8 mb-8">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Интервал назначения</span>
          </div>
          <div class="grid__box grid__box--size-9">
            <div class="grid">
              <div class="grid__box grid__box--size-min">
                {{ ticketInfo.hd_schedule_date | dateFormat: 'DD.MM.YYYY' }}
              </div>
              <div class="grid__box grid__box--size-min">
                <div class="grid grid--gap-4">
                  <div class="grid__box grid__box--size-min">
                    {{ ticketInfo.hd_schedule_intbegin | dateFormat: 'HH:mm' }}
                  </div>
                  <div class="grid__box grid__box--size-min">
                    <div class="mdash"></div>
                  </div>
                  <div class="grid__box grid__box--size-min">
                    {{ ticketInfo.hd_schedule_intend | dateFormat: 'HH:mm' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid mt-8 mb-8" *ngIf="ticketInfo.extra_flags && ticketInfo.extra_flags.ctn">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">CTN</span>
          </div>
          <div class="grid__box grid__box--size-9">
            {{ ticketInfo.extra_flags.ctn }}
          </div>
        </div>
      </div>
      <div class="mt-32">
        <div class="grid mt-8 mb-8">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Ссылка на заявку в HD</span>
          </div>
          <div class="grid__box grid__box--size-9">
            <a class="link" target="_blank" href="{{ ticketInfo.hd_ticket_url }}">{{ ticketInfo.hd_ticket_number }}</a>
          </div>
        </div>
        <div class="grid mt-8 mb-8">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Дата создания</span>
          </div>
          <div class="grid__box grid__box--size-9">
            {{ ticketInfo.hd_create_date | dateFormat: 'DD.MM.YYYY HH:mm' }}
          </div>
        </div>
        <div class="grid mt-8 mb-8" *ngIf="ticketInfo.ticket_type.id === 5">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Оформил с ошибкой</span>
          </div>
          <div class="grid__box grid__box--size-9">
            {{ ticketInfo.edo.brigade_created_contract.brigade_name }}
          </div>
        </div>
        <div class="grid mt-8 mb-8" *ngIf="ticketInfo.ticket_type && ticketInfo.ticket_type.id !== 4">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">ФИО абонента</span>
          </div>
          <div class="grid__box grid__box--size-9">
            <div class="grid grid--gap-8">
              <div class="grid__box grid__box--size-min">
                <a class="link" target="_blank" href="{{ ticketInfo.hd_contract_url }}">{{ ticketInfo.c_bill_name }}</a>
              </div>
              <div class="grid__box grid__box--size-min">
                <app-callback [ticketNumber]="ticketInfo && ticketInfo.hd_ticket_number"></app-callback>
              </div>
            </div>
          </div>
        </div>
        <div class="grid mt-8 mb-8" *ngIf="ticketInfo.ticket_type && ticketInfo.ticket_type.id !== 4">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Статус подключения</span>
          </div>
          <div class="grid__box grid__box--size-9 pos-r">
            <div class="padding-16" *ngIf="ticketAbonentStatusLoading">
              <app-loader [size]="'small'"></app-loader>
            </div>
            <div *ngIf="!ticketAbonentStatusLoading">
              <div *ngIf="!ticketAbonentStatusError" style="display: flex; align-items: center; gap: 12px;">
                <span
                  class="font-weight-bold"
                  [ngClass]="{
                    'color-red-dark': ticketAbonentStatus === 'OFFLINE',
                    'color-green-dark': ticketAbonentStatus === 'ONLINE'
                  }"
                  >{{ ticketAbonentStatus }}</span
                >
                <span
                  style="cursor: pointer; border-bottom: 1px dashed #333; color: #333; font-size: 13px;"
                  (click)="refreshAbonentStatus()"
                >Обновить</span>
              </div>
              <div *ngIf="ticketAbonentStatusError">
                <app-message [type]="'error'" [size]="'small'">
                  <div message-content>
                    {{ ticketAbonentStatusError }}
                  </div>
                </app-message>
              </div>
            </div>
          </div>
        </div>
        <div class="grid mt-8 mb-8" *ngIf="ticketInfo.ticket_type && ticketInfo.ticket_type.id !== 3 && ticketInfo.ticket_type.id !== 4">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Сервисы</span>
          </div>
          <div class="grid__box grid__box--size-9">
            <div>
              <ng-container *ngIf="ticketInfo.ticket_type.id === 1 && ticketInfo.hd_ticket_type.id === 1 && !ticketInfo.extra_flags.moveaddr">
                <span class="color-red-dark">Нет сервисов</span>
              </ng-container>
              <ng-container *ngIf="ticketInfo.ticket_type.id === 1 && ticketInfo.hd_ticket_type.id !== 1">
                <app-tickets-services [services]="ticketInfo.services" [ticket]="ticketInfo" [grouped]="false"></app-tickets-services>
              </ng-container>
              <ng-container *ngIf="ticketInfo.ticket_type.id === 1 && ticketInfo.hd_ticket_type.id === 1 && ticketInfo.extra_flags.moveaddr">
                <app-tickets-services [services]="ticketInfo.services" [ticket]="ticketInfo" [grouped]="false"></app-tickets-services>
              </ng-container>
              <ng-container *ngIf="ticketInfo.ticket_type.id === 2">
                <app-tickets-services [services]="ticketInfo.services" [ticket]="ticketInfo" [grouped]="false"></app-tickets-services>
              </ng-container>
            </div>
            <!--                        <div *ngIf="!isExistsServices" class="mdash"></div>-->
          </div>
        </div>
        <div class="grid mt-8 mb-8" *ngIf="ticketInfo.ticket_type && ticketInfo.ticket_type.id !== 3 && ticketInfo.ticket_type.id !== 4">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Дополнительно</span>
          </div>
          <div class="grid__box grid__box--size-9">
            <div *ngIf="isExistsExtra">
              <app-tickets-extra [ticket]="ticketInfo"></app-tickets-extra>
            </div>
            <div *ngIf="!isExistsExtra" class="mdash"></div>
          </div>
        </div>
        <div class="grid mt-8 mb-8" *ngIf="ticketInfo.ticket_bind_number">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Связанная заявка</span>
          </div>
          <div class="grid__box grid__box--size-9">
            <div *ngIf="ticketInfo.ticket_bind_number">
              <a class="link" target="_blank" href="{{ ticketInfo.hd_ticket_bind_url }}">
                {{ ticketInfo.ticket_bind_number }}
              </a>
              Настройка ТВ при переезде
            </div>
          </div>
        </div>
        <div class="grid mt-8 mb-8" *ngIf="ticketInfo.ma_activation_code">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Код активации</span>
          </div>
          <div class="grid__box grid__box--size-9">
            <div *ngIf="ticketInfo.ma_activation_code">
              {{ ticketInfo.ma_activation_code }}
            </div>
          </div>
        </div>
        <div class="grid mt-8 mb-8">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Статус</span>
          </div>
          <div class="grid__box grid__box--size-9">
            <div class="grid">
              <div class="grid__box grid__box--size-min">
                {{ ticketInfo.ticket_status && ticketInfo.ticket_status.name }}
              </div>
              <div class="grid__box grid__box--size-min">
                <app-ticket-status-change [ticket]="ticketInfo"></app-ticket-status-change>
              </div>
            </div>
          </div>
        </div>
        <div class="grid mt-8 mb-8">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Чек-лист</span>
          </div>
          <div class="grid__box grid__box--size-9">
            <div class="grid">
              <app-checklist-ticket-answers class="ml-8 mb-8" [ticket]="checklistTicket" [answers]="checklistAnswers"> </app-checklist-ticket-answers>
            </div>
          </div>
        </div>
        <div class="grid mt-8 mb-8">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Фото</span>
          </div>
          <div class="grid__box grid__box--size-9">
            <div class="grid">
              <app-loader *ngIf="isAnyLoading; else media" size="small" class="loader"></app-loader>
              <ng-template #media>
                <app-checklist-ticket-media class="ml-8" [ticket]="checklistTicket" [downloadMedia]="downloadMedia"> </app-checklist-ticket-media>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="grid mt-8 mb-8">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Документ PDF</span>
          </div>
          <div class="grid__box grid__box--size-9">
            <div class="grid">
              <app-loader *ngIf="isAnyLoading; else pdf" size="small" class="loader"></app-loader>
              <ng-template #pdf>
                <app-checklist-ticket-pdf class="ml-8" [ticket]="checklistTicket" [downloadPdf]="downloadPdf"> </app-checklist-ticket-pdf>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="grid mt-8 mb-8" *ngIf="ticketInfo.ticket_type.id === 5">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Ошибка в заявке</span>
          </div>
          <div class="grid__box grid__box--size-9">
            <a class="link" [routerLink]="['/' + TICKETS_PATHS.ticketLink + '/' + ticketInfo.edo.contract_problem_ticket_id]">
              {{ ticketInfo.edo.contract_problem_ticket_number }}
            </a>
          </div>
        </div>
      </div>
      <div class="mt-32">
        <div class="grid">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s">Комментарии</span>
            <div class="mt-4 mb-4">
              <a
                class="link"
                (click)="changeTicketCommentType()"
                [ngClass]="{
                  'link--dotted-gray': ticketCommentTypeSelected !== 'HD',
                  'link--no-underline link--not-hovered': ticketCommentTypeSelected === 'HD'
                }"
              >
                из HelpDesk({{ (ticketHdComments && ticketHdComments.length) || 0 }})
              </a>
            </div>
            <div class="mt-4 mb-4">
              <a
                class="link"
                (click)="changeTicketCommentType()"
                [ngClass]="{
                  'link--dotted-gray': ticketCommentTypeSelected !== 'ESAS',
                  'link--no-underline link--not-hovered': ticketCommentTypeSelected === 'ESAS'
                }"
              >
                из {{ Enums.projectName }} ({{ (ticketInfo.esas_comments && ticketInfo.esas_comments.length) || 0 }})
              </a>
            </div>
          </div>
          <div class="grid__box grid__box--size-9">
            <div *ngIf="ticketCommentTypeSelected === 'HD'" class="pos-r">
              <div *ngIf="ticketHdCommentsLoading" class="padding-16">
                <app-loader [size]="'small'"></app-loader>
              </div>
              <ng-container *ngIf="!ticketHdCommentsLoading">
                <div *ngIf="ticketHdCommentsError" class="mb-16">
                  <div class="grid grid--gap-4">
                    <div class="grid__box">
                      <app-message [type]="'error'" [size]="'small'">
                        <div message-content>
                          {{ ticketHdCommentsError }}
                        </div>
                      </app-message>
                    </div>
                  </div>
                </div>
                <div *ngIf="!ticketHdCommentsError">
                  <ng-container *ngIf="ticketHdComments && ticketHdComments.length">
                    <div class="mb-16" *ngFor="let comment of ticketHdComments | ticketViewCommentsPart: ticketCommentTypeMode">
                      <div class="grid">
                        <div class="grid__box grid__box--size-min">
                          <span class="title title--s">
                            {{ comment.creation_date | dateFormat: 'DD.MM.YYYY HH:mm' }}
                          </span>
                        </div>
                        <div class="grid__box grid__box--size-min">
                          <span class="title title--s">{{ comment.created_by }}</span>
                        </div>
                      </div>
                      <div *ngIf="comment.text" [innerHTML]="comment.text"></div>
                    </div>
                  </ng-container>
                  <div class="mb-16" *ngIf="ticketHdComments && !ticketHdComments.length">
                    <span class="color-gray-dark"> Комментариев пока нет. </span>
                  </div>
                </div>
              </ng-container>
            </div>
            <div *ngIf="ticketCommentTypeSelected === 'ESAS'">
              <ng-container *ngIf="ticketInfo && ticketInfo.esas_comments && ticketInfo.esas_comments.length">
                <div class="mb-16" *ngFor="let comment of ticketInfo.esas_comments | ticketViewCommentsPart: ticketCommentTypeMode">
                  <div class="grid">
                    <div class="grid__box grid__box--size-min">
                      <span class="title title--s">
                        {{ comment.create_date | dateFormat: 'DD.MM.YYYY HH:mm' }}
                      </span>
                    </div>
                    <div class="grid__box grid__box--size-min">
                      <span class="title title--s">{{ comment.user_name }}</span>
                    </div>
                  </div>
                  <div>{{ comment.comment }}</div>
                </div>
              </ng-container>
              <div class="mb-16" *ngIf="(ticketInfo && !ticketInfo.esas_comments) || !ticketInfo.esas_comments.length">
                <span class="color-gray-dark"> Комментариев пока нет. </span>
              </div>
            </div>
            <div class="grid">
              <div
                class="grid__box grid__box--size-min"
                *ngIf="
                  (ticketCommentTypeSelected === 'HD' && ticketHdComments && ticketHdComments.length > 1) ||
                  (ticketCommentTypeSelected === 'ESAS' && ticketInfo.esas_comments && ticketInfo.esas_comments.length > 1)
                "
              >
                <ng-container *ngIf="ticketCommentTypeSelected === 'HD' && ticketHdComments && ticketHdComments.length > 1">
                  <div (click)="changeCommentsMode()">
                    <a class="link link--dotted-blue-dark" *ngIf="ticketCommentTypeMode === 'collapsed'">Показать все</a>
                    <a class="link link--dotted-blue-dark" *ngIf="ticketCommentTypeMode === 'expanded'">Свернуть</a>
                  </div>
                </ng-container>
                <ng-container *ngIf="ticketCommentTypeSelected === 'ESAS' && ticketInfo.esas_comments && ticketInfo.esas_comments.length > 1">
                  <div (click)="changeCommentsMode()">
                    <a class="link link--dotted-blue-dark" *ngIf="ticketCommentTypeMode === 'collapsed'">Показать все</a>
                    <a class="link link--dotted-blue-dark" *ngIf="ticketCommentTypeMode === 'expanded'">Свернуть</a>
                  </div>
                </ng-container>
              </div>
              <div class="grid__box grid__box--size-min">
                <app-add-comment [type]="ticketCommentTypeSelected" [ticketId]="ticketInfo.id" (addEsasComment)="addEsasComment($event)"></app-add-comment>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="delimiter delimiter--gray-bright delimiter--size-1 mt-24 mb-24" *ngIf="ticketInfo.ticket_type && ticketInfo.ticket_type.id !== 4"></div>
      <div *ngIf="ticketInfo.ticket_type && ticketInfo.ticket_type.id !== 4">
        <div class="grid" *ngIf="ticketGlobalProblems">
          <div class="grid__box grid__box--size-3">
            <span class="title title--s"> ГП на адресе({{ ticketGlobalProblems && ticketGlobalProblems.length }}) </span>
          </div>
          <div class="grid__box grid__box--size-9" *ngIf="ticketGlobalProblems && ticketGlobalProblems.length">
            <div *ngFor="let gp of ticketGlobalProblems | ticketViewCommentsPart: gpTypeMode; let last = last" [ngClass]="{ 'mb-24': !last }">
              <div class="grid">
                <div class="grid__box grid__box--size-min">
                  <a class="link link--bold" href="{{ gp.gp_link }}" target="_blank">{{ gp.number }}</a>
                </div>
                <div class="grid__box grid__box--size-min">
                  {{ gp.scale }}
                  <span *ngIf="gp.ticket && gp.ticket.ticket_type && gp.ticket.ticket_type.name">
                    /
                    {{ gp.ticket && gp.ticket.ticket_type && gp.ticket.ticket_type.name }}
                  </span>
                </div>
              </div>
              <div class="font-weight-bold">
                <div class="grid grid--gap-8">
                  <div class="grid__box grid__box--size-min">
                    {{ gp.start_date | dateFormat: 'DD MMMM YYYY HH:mm' }}
                  </div>
                  <div class="grid__box grid__box--size-min">
                    <div class="mdash"></div>
                  </div>
                  <div class="grid__box grid__box--size-min">
                    {{ gp.end_date | dateFormat: 'DD MMMM YYYY HH:mm' }}
                  </div>
                </div>
              </div>
              <div>{{ gp.description }}</div>
            </div>
            <div class="mt-16">
              <ng-container *ngIf="ticketGlobalProblems && ticketGlobalProblems.length > 1">
                <div (click)="changeGPMode()">
                  <a class="link link--dotted-blue-dark" *ngIf="gpTypeMode === 'collapsed'">Показать все</a>
                  <a class="link link--dotted-blue-dark" *ngIf="gpTypeMode === 'expanded'">Свернуть</a>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="grid__box grid__box--size-9" *ngIf="ticketGlobalProblems && !ticketGlobalProblems.length">Глобальные проблемы отсутствуют</div>
        </div>
      </div>
    </div>
  </div>

  <div class="print-section">
    <div>
      <div class="title title--big">Заявка №{{ ticketInfo.hd_ticket_number }}</div>
    </div>
    <div class="grid mt-24">
      <div class="grid__box grid__box--size-12">
        <div>
          <div class="grid mt-4 mb-4">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Тип</span>
            </div>
            <div class="grid__box grid__box--size-9">
              <span class="title title--s">{{ ticketInfo.ticket_type && ticketInfo.ticket_type.name }}</span>
              <span *ngIf="ticketInfo.ticket_subtype"> / {{ ticketInfo.ticket_subtype }}</span>
            </div>
          </div>
          <div *ngIf="ticketInfo.ticket_type && ticketInfo.ticket_type.id === 4">
            <div class="grid mt-8 mb-8">
              <div class="grid__box grid__box--size-3">
                <span class="title title--s">Масштаб</span>
              </div>
              <div class="grid__box grid__box--size-9">
                {{ ticketInfo.scale_and_priority }}
              </div>
            </div>
            <div class="grid mt-8 mb-8">
              <div class="grid__box grid__box--size-3">
                <span class="title title--s">Период действия</span>
              </div>
              <div class="grid__box grid__box--size-9">
                {{ ticketInfo.period }}
              </div>
            </div>
            <div class="grid mt-8 mb-8">
              <div class="grid__box grid__box--size-3">
                <span class="title title--s">Влияние на сервис</span>
              </div>
              <div class="grid__box grid__box--size-9">
                {{ ticketInfo.affected_services }}
              </div>
            </div>
          </div>
          <div class="grid mt-4 mb-4">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Адрес</span>
            </div>
            <div class="grid__box grid__box--size-9">
              {{ ticketInfo.hd_address }}
            </div>
          </div>
          <div class="grid mt-8 mb-8" *ngIf="ticketInfo.ticket_type && ticketInfo.ticket_type.id === 4">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Описание</span>
            </div>
            <div class="grid__box grid__box--size-9">
              {{ ticketInfo.description }}
            </div>
          </div>
          <div class="grid mt-4 mb-4">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Участок</span>
            </div>
            <div class="grid__box grid__box--size-9">
              {{ ticketInfo.district && ticketInfo.district.sector_number_str }}
            </div>
          </div>
          <div class="grid mt-4 mb-4">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Назначена на бригаду</span>
            </div>
            <div class="grid__box grid__box--size-9">
              {{ ticketInfo.brigade && ticketInfo.brigade.brigade_name }}
            </div>
          </div>
          <div *ngIf="brigadeInfo">
            <div class="grid mt-4 mb-4">
              <div class="grid__box grid__box--size-3">
                <span class="title title--s">Бригадир</span>
              </div>
              <div class="grid__box grid__box--size-9">
                <div class="grid">
                  <div class="grid__box grid__box--size-min">
                    {{ brigadeInfo && brigadeInfo.brigade_head && brigadeInfo.brigade_head.employee && brigadeInfo.brigade_head.employee.full_name }}
                  </div>
                  <div class="grid__box grid__box--size-min">
                    <div class="grid grid--gap-4">
                      <div class="grid__box grid__box--size-min">
                        <app-icon [glyph]="'hd-phone-2'" [size]="'14'" [color]="'gray'"></app-icon>
                      </div>
                      <div class="grid__box grid__box--size-min">
                        {{ brigadeInfo && brigadeInfo.brigade_head && brigadeInfo.brigade_head.employee && brigadeInfo.brigade_head.employee.phone | phoneFormat }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid mt-4 mb-4">
              <div class="grid__box grid__box--size-3">
                <span class="title title--s">Состав бригады</span>
              </div>
              <div class="grid__box grid__box--size-9">
                <span *ngFor="let worker of brigadeInfo.brigade_workers; let last = last">
                  {{ worker && worker.employee && worker.employee.full_name }}<span *ngIf="!last">, </span>
                </span>
              </div>
            </div>
          </div>
          <div class="grid mt-4 mb-4">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Интервал назначения</span>
            </div>
            <div class="grid__box grid__box--size-9">
              <div class="grid">
                <div class="grid__box grid__box--size-min">
                  {{ ticketInfo.hd_schedule_date | dateFormat: 'DD.MM.YYYY' }}
                </div>
                <div class="grid__box grid__box--size-min">
                  <div class="grid grid--gap-4">
                    <div class="grid__box grid__box--size-min">
                      {{ ticketInfo.hd_schedule_intbegin | dateFormat: 'HH:mm' }}
                    </div>
                    <div class="grid__box grid__box--size-min">
                      <div class="mdash"></div>
                    </div>
                    <div class="grid__box grid__box--size-min">
                      {{ ticketInfo.hd_schedule_intend | dateFormat: 'HH:mm' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-16">
          <div class="grid mt-4 mb-4">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Ссылка на заявку в HD</span>
            </div>
            <div class="grid__box grid__box--size-9">
              <a class="link" href="{{ ticketInfo.hd_ticket_url }}" target="_blank">{{ ticketInfo.hd_ticket_number }}</a>
            </div>
          </div>
          <div class="grid mt-4 mb-4">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Дата создания</span>
            </div>
            <div class="grid__box grid__box--size-9">
              {{ ticketInfo.hd_create_date | dateFormat: 'DD.MM.YYYY HH:mm' }}
            </div>
          </div>
          <div class="grid mt-8 mb-8" *ngIf="ticketInfo.ticket_type.id === 5">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Оформил с ошибкой</span>
            </div>
            <div class="grid__box grid__box--size-9">
              {{ ticketInfo.edo.brigade_created_contract.brigade_name }}
            </div>
          </div>
          <div class="grid mt-4 mb-4" *ngIf="ticketInfo.ticket_type && ticketInfo.ticket_type.id !== 4">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">ФИО абонента</span>
            </div>
            <div class="grid__box grid__box--size-9">
              <a class="link" href="{{ ticketInfo.hd_contract_url }}">{{ ticketInfo.c_bill_name }}</a>
            </div>
          </div>
          <div class="grid mt-4 mb-4" *ngIf="ticketInfo.ticket_type && ticketInfo.ticket_type.id !== 4">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Статус подключения</span>
            </div>
            <div class="grid__box grid__box--size-9">
              <span
                class="font-weight-bold"
                [ngClass]="{
                  'color-red-dark': ticketAbonentStatus === 'OFFLINE',
                  'color-green-dark': ticketAbonentStatus === 'ONLINE'
                }"
                >{{ ticketAbonentStatus }}</span
              >
            </div>
          </div>
          <div class="grid mt-8 mb-8" *ngIf="ticketInfo.ticket_type && ticketInfo.ticket_type.id !== 3 && ticketInfo.ticket_type.id !== 4">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Сервисы</span>
            </div>
            <div class="grid__box grid__box--size-9">
              <div>
                <ng-container *ngIf="ticketInfo.ticket_type.id === 1 && ticketInfo.hd_ticket_type.id === 1 && !ticketInfo.extra_flags.moveaddr">
                  <span class="color-red-dark">Нет сервисов</span>
                </ng-container>
                <ng-container *ngIf="ticketInfo.ticket_type.id === 1 && ticketInfo.hd_ticket_type.id !== 1">
                  <app-tickets-services [services]="ticketInfo.services" [ticket]="ticketInfo"></app-tickets-services>
                </ng-container>
                <ng-container *ngIf="ticketInfo.ticket_type.id === 1 && ticketInfo.hd_ticket_type.id === 1 && ticketInfo.extra_flags.moveaddr">
                  <app-tickets-services [services]="ticketInfo.services" [ticket]="ticketInfo"></app-tickets-services>
                </ng-container>
                <ng-container *ngIf="ticketInfo.ticket_type.id === 2">
                  <app-tickets-services [services]="ticketInfo.services" [ticket]="ticketInfo"></app-tickets-services>
                </ng-container>
              </div>
              <!--                            <div *ngIf="!isExistsServices" class="mdash"></div>-->
            </div>
          </div>

          <div class="grid mt-8 mb-8" *ngIf="ticketInfo.ticket_type && ticketInfo.ticket_type.id !== 3 && ticketInfo.ticket_type.id !== 4">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Дополнительно</span>
            </div>
            <div class="grid__box grid__box--size-9">
              <div *ngIf="isExistsExtra">
                <app-tickets-extra [ticket]="ticketInfo"></app-tickets-extra>
              </div>
              <div *ngIf="!isExistsExtra" class="mdash"></div>
            </div>
          </div>
          <div class="grid mt-4 mb-4">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Статус</span>
            </div>
            <div class="grid__box grid__box--size-9">
              <div class="grid">
                <div class="grid__box grid__box--size-min">
                  {{ ticketInfo.ticket_status && ticketInfo.ticket_status.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="grid mt-8 mb-8" *ngIf="ticketInfo.ticket_type.id === 5">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Ошибка в заявке</span>
            </div>
            <div class="grid__box grid__box--size-9">
              <a class="link" [routerLink]="['/' + TICKETS_PATHS.ticketLink + '/' + ticketInfo.edo.contract_problem_ticket_id]">
                {{ ticketInfo.edo.contract_problem_ticket_number }}
              </a>
            </div>
          </div>
        </div>
        <div class="mt-16">
          <div class="grid mt-4 mb-4">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Комментарии из HelpDesk</span>
            </div>
            <div class="grid__box grid__box--size-9">
              <ng-container *ngIf="ticketHdComments">
                <div class="mb-8" *ngFor="let commentHd of ticketHdComments">
                  <div class="grid">
                    <div class="grid__box grid__box--size-min">
                      <span class="title title--s">
                        {{ commentHd.creation_date | dateFormat: 'DD.MM.YYYY HH:mm' }}
                      </span>
                    </div>
                    <div class="grid__box grid__box--size-min">
                      <span class="title title--s">{{ commentHd.created_by }}</span>
                    </div>
                  </div>
                  <div *ngIf="commentHd.text" [innerHTML]="commentHd.text"></div>
                </div>
              </ng-container>
              <span class="color-gray-dark" *ngIf="ticketHdComments && !ticketHdComments.length"> Комментариев пока нет. </span>
            </div>
          </div>
          <div class="grid mt-4 mb-4">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s">Комментарии из {{ Enums.projectName }}</span>
            </div>
            <div class="grid__box grid__box--size-9">
              <ng-container *ngIf="ticketInfo && ticketInfo.esas_comments && ticketInfo.esas_comments.length">
                <div class="mb-8" *ngFor="let comment of ticketInfo.esas_comments">
                  <div class="grid">
                    <div class="grid__box grid__box--size-min">
                      <span class="title title--s">
                        {{ comment.create_date | dateFormat: 'DD.MM.YYYY HH:mm' }}
                      </span>
                    </div>
                    <div class="grid__box grid__box--size-min">
                      <span class="title title--s">{{ comment.user_name }}</span>
                    </div>
                  </div>
                  <div>{{ comment.comment }}</div>
                </div>
              </ng-container>
              <span class="color-gray-dark" *ngIf="ticketInfo && !ticketInfo.esas_comments.length"> Комментариев пока нет. </span>
            </div>
          </div>
        </div>

        <div class="delimiter delimiter--gray-bright delimiter--size-1 mt-16 mb-16"></div>
        <div class="mb-16" *ngIf="ticketInfo.ticket_type && ticketInfo.ticket_type.id !== 4">
          <div class="grid" *ngIf="ticketGlobalProblems">
            <div class="grid__box grid__box--size-3">
              <span class="title title--s"> ГП на адресе({{ ticketGlobalProblems && ticketGlobalProblems.length }}) </span>
            </div>
            <div class="grid__box grid__box--size-9" *ngIf="ticketGlobalProblems && ticketGlobalProblems.length">
              <div *ngFor="let gp of ticketGlobalProblems" [ngClass]="{ 'mb-16': !last }">
                <div class="grid">
                  <div class="grid__box grid__box--size-min">
                    <a class="link link--bold" href="{{ gp.gp_link }}" target="_blank">{{ gp.number }}</a>
                  </div>
                  <div class="grid__box grid__box--size-min">
                    {{ gp.scale }}
                    <span *ngIf="gp.ticket && gp.ticket.ticket_type && gp.ticket.ticket_type.name">
                      /
                      {{ gp.ticket && gp.ticket.ticket_type && gp.ticket.ticket_type.name }}
                    </span>
                  </div>
                </div>
                <div class="font-weight-bold">
                  <div class="grid grid--gap-8">
                    <div class="grid__box grid__box--size-min">
                      {{ gp.start_date | dateFormat: 'DD MMMM YYYY HH:mm' }}
                    </div>
                    <div class="grid__box grid__box--size-min">
                      <div class="mdash"></div>
                    </div>
                    <div class="grid__box grid__box--size-min">
                      {{ gp.end_date | dateFormat: 'DD MMMM YYYY HH:mm' }}
                    </div>
                  </div>
                </div>
                <div>{{ gp.description }}</div>
              </div>
            </div>
            <div class="grid__box grid__box--size-9" *ngIf="ticketGlobalProblems && !ticketGlobalProblems.length">Глобальные проблемы отсутствуют</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-32 no-print">
    <div class="grid grid--gap-32">
      <div class="grid__box grid__box--size-min">
        <a (click)="backClicked()" class="link link--dotted-gray-dark">Назад</a>
      </div>
      <div class="grid__box grid__box--size-min">
        <a class="link link--dotted-gray-dark" (click)="printTicket()">Распечатать</a>
      </div>
    </div>
  </div>
</div>
